export default {
  install(Vue) {
    Vue.prototype.$catch = function (res) {
      let $this = this
      if (res.response.status === 500) {
        if (res.response.data.message == "DO_HAS_CONFIRMED") {
          $this.$message(
            $this.$t("app.messages.errors.title"),
            $this.$t("B1000.messages.errors.doHasConfirmed")
          );
        } else if (res.response.data.message == "BL_NO_DUPLICATE") {
          $this.$message(
            $this.$t("app.messages.errors.title"),
            $this.$t("B0400.messages.errors.invalidBlNo")
          );
        } else if (res.response.data.message == "EXCHANGE_RATE_NOT_FOUND") {
          $this.$message(
            $this.$t("app.messages.errors.title"),
            $this.$t("app.messages.errors.exchangeRateNotFound")
          );
        } else if (res.response.data.message == "PRICING_REPEAT") {
          $this.$message(
            $this.$t("app.messages.errors.title"),
            "単価に重複レコードがあります"
          );
        } else if (res.response.data.message == "PRICING_PAYMENT_PRICE_WRONG") {
          $this.$message(
            $this.$t("app.messages.errors.title"),
            "支払い単価が設定されていません"
          );
        } else if (res.response.data.message == "EXCHANGE_RATE_DATE_REPEAT") {
          $this.$message(
            $this.$t("app.messages.errors.title"),
            "為替レート日付の繰り返し"
          );
        } else if (res.response.data.message == "VALUE_CHARGE_ZERO") {
          $this.$message(
            $this.$t("app.messages.errors.title"),
            "商品金額JPYを0にすることはできません"
          );
        } else if (
          res.response.data.message.indexOf('PRICING_NOT_FOUND') !== -1
        ) {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('app.messages.errors.pricingNotFound', {
              chargeItem: res.response.data.message.split(';')[1]
            })
          )
        } else if (res.response.data.message == "INSURANCE_RATE_NOT_FOUND") {
          $this.$message(
            $this.$t("app.messages.errors.title"),
            $this.$t("app.messages.errors.insuranceRateNotFound")
          );
        } else if (res.response.data.message == "TAX_RATE_NOT_FOUND") {
          $this.$message(
            $this.$t("app.messages.errors.title"),
            $this.$t("app.messages.errors.taxRateNotFound")
          );
        } else if (res.response.data.message == "COMMISSION_RATE_NOT_FOUND") {
          this.$message(
            this.$t("app.messages.errors.title"),
            this.$t("app.messages.errors.commissionRateNotFound")
          );
        } else if (res.response.data.message == 'DEVAN_PRICING_REPEAT') {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('app.messages.errors.devanPricingRepeat')
          )
        } else if (res.response.data.message == 'FREIGHT_CHARGE_NOT_CALCULATED') {
          this.$message(
            this.$t('app.messages.errors.title'),
            this.$t('app.messages.errors.freightChargeNotCalculated')
          )
        } else if (res.response.data.message == 'DATA_FROZEN') {
          this.$message(
            this.$t('app.messages.errors.title'),
            'データは凍結済状態ですので該当操作を実施できません'
            // this.$t('app.messages.errors.freightChargeNotCalculated')
          )
        } else if (res.response.data.message == 'CONFIRMED_FIRST') {
          this.$message(
            this.$t('app.messages.errors.title'),
            '请先承认该数据'
            // this.$t('app.messages.errors.freightChargeNotCalculated')
          )
        } else if (res.response.data.message == 'ALL_UNPAID_NEED_ISSUE') {
          this.$message(
            this.$t('app.messages.errors.title'),
            '纯无偿'
            // this.$t('app.messages.errors.freightChargeNotCalculated')
          )
        } else if (res.response.data.message == 'CURRENCY_CODE_NOT_EXISTS') {
          this.$message(
            this.$t('app.messages.errors.title'),
            '通貨が存在していませんので、保存できません。'
          )
        } else if (res.response.data.message == 'NOT_SAME_DRAKE_SHARING_GROUP') {
          this.$message(
            this.$t('app.messages.errors.title'),
            '配送パターンが異なるので、乗合できません。'
          )
        } else if (res.response.data.message == 'MIX_DRAKE_SHARING_GROUP') {
          this.$message(
            this.$t('app.messages.errors.title'),
            '乗合計算済みのDOが追加できません'
          )
        } else if (res.response.data.message == 'DRAKE_ALREADY_CALCULATED') {
          this.$message(
            this.$t('app.messages.errors.title'),
            '諸掛費用計算が完了しているので、乗合できません。'
          )
        } else if (res.response.data.message == 'NOT_VALID_DRAKE_SHARING_PATH') {
          this.$message(
            this.$t('app.messages.errors.title'),
            '乗合不可'
          )
        } else if (res.response.data.message == "EXCEL_TEMPLATE_NOT_RIGHT") {
          $this.$message(
            $this.$t("app.messages.errors.title"),
            `不正なテンプレート`
          );
        } else if (res.response.data.message == "CHARGE_ITEM_TAX_NOT_RIGHT") {
          $this.$message(
            $this.$t("app.messages.errors.title"),
            `税金がおかしい `
          );
        } else {
          $this.$message(
            this.$t("app.messages.errors.title"),
            `system error, module:${this.$route.path}`
          )
        }
      }

    }
  }
}